import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { DerayahStatus } from '../../../../types/derayah';

const SUCCESS_STATUSES: DerayahStatus[] = ['COMPLETED', 'REFLECTED', 'CONFIRMED'];
const ERROR_STATUSES: DerayahStatus[] = ['FAILED', 'PARTIALLY_FAILED'];
const NEUTRAL_STATUSES: DerayahStatus[] = ['CANCELLED'];

const getStatusColor = (status: DerayahStatus): ChipProps['color'] => {
  if (SUCCESS_STATUSES.includes(status)) return 'success';
  if (ERROR_STATUSES.includes(status)) return 'error';
  if (NEUTRAL_STATUSES.includes(status)) return 'default';
  // Everything else is pending / awaiting / submitted / initiated.
  return 'warning';
};

interface DerayahStatusChipProps {
  status: DerayahStatus;
}

export function DerayahStatusChip({ status }: DerayahStatusChipProps) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={getStatusColor(status)}
      label={status.replace(/_/g, ' ')}
      title={status}
      sx={{ fontWeight: 600 }}
    />
  );
}
